export default __webpack_public_path__ + "static/media/SharpGroteskSmBold19.42b4f9ce.woff2";